module.exports = __webpack_public_path__ + "static/media/hand_blue.5944f8a6.svg";